import React, { Component } from "react";
import { observer } from "mobx-react";
import { AxiosResponse } from "axios";
import { getRequest } from "../../utils/httpRequest";
import { isLoggedIn } from "../../utils/session";
import { compareCourses } from "../../stores/CoursesStore/helpers";
import { OngoingEnrolment } from "../../stores/ProfileStore/Types";

interface State {
  ongoingEnrolments: OngoingEnrolment[];
  loading: boolean;
}

class Courses extends Component<{}, State> {
  constructor(props) {
    super(props);

    this.state = {
      ongoingEnrolments: [],
      loading: true,
    };
  }

  componentDidMount() {
    // Signed out this returns [], so skip the round trip and settle the loader.
    if (!isLoggedIn()) {
      this.setState({ loading: false });
      return;
    }

    return getRequest("/api/users/enrolments.json").then(
      (response: AxiosResponse<OngoingEnrolment[]>) => {
        this.setState({ ongoingEnrolments: response.data, loading: false });
      },
    );
  }

  render() {
    const { ongoingEnrolments, loading } = this.state;
    const sortedCourses = ongoingEnrolments?.sort(compareCourses);

    return (
      <>
        {loading && (
          <div className="pf-section">
            <div className="ui active inverted dimmer">
              <div className="ui text loader">Loading</div>
            </div>
          </div>
        )}
        {sortedCourses.length > 0 ? (
          <div className="pf-section">
            <div className="pf-section-label">Continue learning</div>
            <div className="pf-continue-wrap">
              <div
                className={`pf-courses ${
                  sortedCourses.length > 3 ? "is-scroll" : ""
                }`}
              >
                {sortedCourses.map((course, i) => (
                  <a
                    className="pf-course"
                    href={`/enrolments/${course.id}`}
                    key={i}
                  >
                    <span
                      className="pf-ring"
                      style={
                        {
                          "--pct": course.percentage_completed,
                        } as React.CSSProperties
                      }
                    >
                      <span>{course.percentage_completed}%</span>
                    </span>
                    <span className="pf-course-tx">{course.name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="pf-section">
            <div className="pf-section-label">Continue learning</div>
            <p className="pf-empty">You have no ongoing courses.</p>
          </div>
        )}
      </>
    );
  }
}

export default observer(Courses);
